export const imgList: Record<
    string,
    {
        pc: string;
        h5: string;
    }
> = {
    uk: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1727602516906/UK-1200x300.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1727602520620/UK-375x500.jpg',
    },
    eu: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1727602419264/EU-1200x300.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1727602423726/EU-375x500.jpg',
    },
    us: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1729757165716/na_ecocredits11_PC.png',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1729757177091/na_ecocredits_M.png',
    },
    ca: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1729757165716/na_ecocredits11_PC.png',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1729757177091/na_ecocredits_M.png',
    },
    za: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1728899156875/pc-activity-kv-1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1728899282089/m-activity-kv-1.jpg',
    },
    kr: {
        pc: 'https://ecoflow-service-eu-cdn.ecoflow.com/upload/image/1719217836760/EU-1200x300.jpg',
        h5: 'https://ecoflow-service-eu-cdn.ecoflow.com/upload/image/1719217854349/EU-375x500.jpg',
    },
    au: {
        pc: 'https://ecoflow-service-eu-cdn.ecoflow.com/upload/image/1719217836760/EU-1200x300.jpg',
        h5: 'https://ecoflow-service-eu-cdn.ecoflow.com/upload/image/1719217854349/EU-375x500.jpg',
    },
};
